import React, { ClipboardEventHandler, PureComponent } from 'react';
import { Button, Input } from '@missionlabs/smartagent-app-components';
import Asterisk from './buttons/Asterisk.svg'
import Hashtag from './buttons/Hashtag.svg'
import PlusSign from './buttons/PlusSign.svg'

const dialButtons = [
	{ text: '1' },
	{ text: '2', label: 'ABC' },
	{ text: '3', label: 'DEF' },
	{ text: '4', label: 'GHI' },
	{ text: '5', label: 'JKL' },
	{ text: '6', label: 'MNO' },
	{ text: '7', label: 'PQRS' },
	{ text: '8', label: 'TUV' },
	{ text: '9', label: 'WXYZ' },
	{ text: '*' },
	{ text: '0', label: '+' },
	{ text: '#' },
]

interface Props {
	recordPresses?: boolean
}

interface Actions {
	onKeypadButton: (text: string) => void
}

export default class Keypad extends PureComponent<Props & Actions> {
	state = {
		presses: "",
		inputValue: "",
		disableInput: false,
	}
	onKeypadButton = (text: string) => {
		if (this.props.recordPresses) {
			this.setState({ presses: this.state.presses + text })
		}

		this.setState({
			...this.state,
			inputValue: this.state.inputValue + text,
		})

		setTimeout(() => {
			inputElement?.scroll(inputElement.scrollWidth, inputElement.scrollWidth);
			inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length)
		}, 1);
		const inputElement = document.getElementById('dialler-input') as HTMLInputElement;

		inputElement?.focus();
		this.props.onKeypadButton(text);
		inputElement?.focus();
	}

	onInputChange = (text: any) => {
		const value = typeof text === 'string' ? text : text.key
		for (let i = 0; i < value.length; i++) {
			if (!isValidCharacter(value[i])) {
				return;
			}
		}
		this.props.onKeypadButton(value);
		this.setState({
			inputValue: this.state.inputValue + value
		})
	}
	

	disableInput = (time: number) => {
		this.setState((prevState) => ({
			...prevState,
			disableInput: true,
		}))
		setTimeout(() => {
			this.setState((prevState) => ({
				...prevState,
				disableInput: false,
			}))
		}, time);
	}

	onPaste = (text: string) => {
		let safeString = '';
		for (let i = 0; i < text.length; i++) {
			if (isValidCharacter(text[i])) {
				safeString += text[i]
			}
		}
		if (!safeString) return;
		if (this.props.recordPresses && safeString.length > 1) {
			this.disableInput(2000)
		}
		this.onInputChange(safeString);
	}

	render() {
		return (
			<div className='keypad' onClick={(e) => document.getElementById('dialler-input')?.focus()} onKeyDown={(e) => this.onInputChange(e)}>
				<span className="keypad-presses">{this.state.presses}</span>
				{
					// this.props.recordPresses &&
					<Input
						onPaste={(e) => this.onPaste(e.clipboardData.getData('text/plain')?.trim())}
						id='dialler-input'
						className={`dialler-input${this.state.disableInput ? ' disabled' : ''}`}
						value={this.state.inputValue}
						draggable={false}
						onChange={() => { }}
						disabled={this.state.disableInput}
					>
					</Input>
				}

				<div className="keypad-buttons" onClick={(e) => document.getElementById('dialler-input')?.focus()}>
					{dialButtons.map(button => {
						return (
							<Button onFocus={() => document.getElementById('dialler-input')?.focus()} key={button.text} title={`${button.text} - ${button.label}`} className={`keypad-button ${this.state.disableInput ? 'disabled' : ''}`} onClick={() => {
								this.onKeypadButton(button.text)
								document.getElementById('dialler-input')?.focus()
							}}>
								<span className='keypad-text'>{
									button.text === '#' ? <img src={Hashtag} alt='Hash' title="Hash" width="30px" height="30px" /> :
										button.text === '*' ? <img src={Asterisk} alt='Asterisk' title="Asterisk" width="30px" height="30px" /> :
											button.text
								}</span>

								{button.label === '+' ? <img src={PlusSign} alt='Plus sign' title="Plus" width="22px" height="22px" /> : <span className='keypad-label'>{button.label}</span>}
							</Button>
						)
					})}
				</div>
			</div>
		)
	}
}

const isValidCharacter = (text: string) => {
	const validChars = new Set(["+", "#", "*", "0"]);
	return validChars.has(text) || /^\d+$/.test(text);
}		